
<div class="job-approval-wrapper">
  <div class="page-header">
    <h2>Job Approvals</h2>
    <p>{{ total }} jobs awaiting your review.</p>
  </div>

  <ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <div class="approval-card">
        <div class="table-toolbar">
          <div class="search-box">
            <i class="bi bi-search"></i>
            <input
              type="text"
              placeholder="Search jobs..."
              [(ngModel)]="searchTerm"
              (input)="onSearchChange()"
            />
          </div>

          <div class="toolbar-actions">
            <!-- Company Dropdown -->
            <div class="custom-select-container">
              <button
                class="select-trigger"
                [class.active]="companyDropdownOpen"
                (click)="toggleCompanyDropdown(); $event.stopPropagation()"
              >
                <span>{{ selectedCompany }}</span>
                <i class="bi bi-chevron-down select-arrow"></i>
              </button>

              <div class="select-dropdown-menu" *ngIf="companyDropdownOpen">
                <div
                  class="select-dropdown-item"
                  *ngFor="let comp of companies"
                  [class.active]="comp === selectedCompany"
                  (click)="selectCompany(comp)"
                >
                  {{ comp }}
                </div>
              </div>
            </div>

            <!-- Job Role Dropdown -->
            <div class="custom-select-container">
              <button
                class="select-trigger"
                [class.active]="jobRoleDropdownOpen"
                (click)="toggleJobRoleDropdown(); $event.stopPropagation()"
              >
                <span>{{ selectedJobRole }}</span>
                <i class="bi bi-chevron-down select-arrow"></i>
              </button>

              <div class="select-dropdown-menu" *ngIf="jobRoleDropdownOpen">
                <div
                  class="select-dropdown-item"
                  *ngFor="let role of jobRoles"
                  [class.active]="role === selectedJobRole"
                  (click)="selectJobRole(role)"
                >
                  {{ role }}
                </div>
              </div>
            </div>

            <!-- Work Mode Dropdown -->
            <div class="custom-select-container">
              <button
                class="select-trigger"
                [class.active]="workModeDropdownOpen"
                (click)="toggleWorkModeDropdown(); $event.stopPropagation()"
              >
                <span>{{ selectedWorkMode }}</span>
                <i class="bi bi-chevron-down select-arrow"></i>
              </button>

              <div class="select-dropdown-menu" *ngIf="workModeDropdownOpen">
                <div
                  class="select-dropdown-item"
                  *ngFor="let mode of workModes"
                  [class.active]="mode === selectedWorkMode"
                  (click)="selectWorkMode(mode)"
                >
                  {{ mode }}
                </div>
              </div>
            </div>

            <div class="custom-select-container">
              <button
                class="select-trigger"
                [class.active]="typeDropdownOpen"
                (click)="toggleTypeDropdown(); $event.stopPropagation()"
              >
                <span>{{ selectedType }}</span>
                <i class="bi bi-chevron-down select-arrow"></i>
              </button>

              <div class="select-dropdown-menu" *ngIf="typeDropdownOpen">
                <div
                  class="select-dropdown-item"
                  *ngFor="let t of types"
                  [class.active]="t === selectedType"
                  (click)="selectType(t)"
                >
                  {{ t }}
                </div>
              </div>
            </div>
            <!---
            <div class="custom-select-container">
              <button
                class="select-trigger"
                [class.active]="statusDropdownOpen"
                (click)="toggleStatusDropdown(); $event.stopPropagation()"
              >
                <span>{{ selectedStatus }}</span>
                <i class="bi bi-chevron-down select-arrow"></i>
              </button>

              <div class="select-dropdown-menu" *ngIf="statusDropdownOpen">
                <div
                  class="select-dropdown-item"
                  *ngFor="let status of statuses"
                  [class.active]="status === selectedStatus"
                  (click)="selectStatus(status)"
                >
                  {{ status }}
                </div>
              </div>
            </div>  -->

            <div class="date-filter" style="display: flex; align-items: center; gap: 8px; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; background: white; margin-right: 12px;">
              <span style="font-size: 12px; color: #64748b; font-weight: 500;">Submitted:</span>
              <input
                type="date"
                [(ngModel)]="selectedSubmittedDate"
                (change)="onDateChange()"
                style="border: none; outline: none; font-size: 14px; color: #1e293b; background: transparent; cursor: pointer;"
              />
              <button *ngIf="selectedSubmittedDate" (click)="clearSubmittedDateFilter()" style="border: none; background: transparent; cursor: pointer; display: flex; align-items: center; padding: 0;">
                <span class="material-icons" style="font-size: 16px; color: #94a3b8;">close</span>
              </button>
            </div>

            <!-- <div class="date-filter" style="display: flex; align-items: center; gap: 8px; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; background: white; margin-right: 12px;">
              <span style="font-size: 12px; color: #64748b; font-weight: 500;">Deadline:</span>
              <input
                type="date"
                [(ngModel)]="selectedDeadlineDate"
                (change)="onDateChange()"
                style="border: none; outline: none; font-size: 14px; color: #1e293b; background: transparent; cursor: pointer;"
              />
              <button *ngIf="selectedDeadlineDate" (click)="clearDeadlineDateFilter()" style="border: none; background: transparent; cursor: pointer; display: flex; align-items: center; padding: 0;">
                <span class="material-icons" style="font-size: 16px; color: #94a3b8;">close</span>
              </button>
            </div> -->

            <button class="export-btn" (click)="exportToExcel()">
              <i class="bi bi-download"></i>
              Export
            </button>
          </div>
        </div>

        <div class="table-divider"></div>
        <ng-container *ngIf="jobApprovals.length > 0; else showMessage">
          <div class="table-container">
          <table>
            <thead>
              <tr>
                <th (click)="sortData('company_name')" class="sortable">
                  <div class="th-content">
                    Company
                    <i class="bi bi-arrow-down-up"></i>
                  </div>
                </th>
                <th (click)="sortData('job_title')" class="sortable">
                  <div class="th-content">
                    Job Title
                    <i class="bi bi-arrow-down-up"></i>
                  </div>
                </th>
                <th>Type</th>
                <th>Work Mode</th>
                <th>Location</th>
                <th (click)="sortData('submitted_at')" class="sortable">
                  <div class="th-content">
                    Submitted
                    <i class="bi bi-arrow-down-up"></i>
                  </div>
                </th>
                <th style="text-align: center"></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let jobApproval of jobApprovals">
                <td>
                  <div class="company-cell">
                    <div class="logo" [style.background]="jobApproval.logo_url ? 'transparent' : '#4f46e5'">
                      <img *ngIf="jobApproval.logo_url" [src]="jobApproval.logo_url" alt="Logo"
                        class="company-logo-img" />
                      <span *ngIf="!jobApproval.logo_url">
                        {{ jobApproval.company_name.substring(0, 2).toUpperCase() }}
                      </span>
                    </div>
                    <span>{{ jobApproval.company_name }}</span>
                  </div>
                </td>

                <td>{{ jobApproval.job_title }}</td>
                <td>{{ jobApproval.job_type }}</td>
                <td>{{ jobApproval.work_mode }}</td>
                <td>{{ jobApproval.locations.join(", ") }}</td>
                <td>{{ jobApproval.submitted_at | date: "dd MMM yyyy" }}</td>

                <td>
                  <div class="actions">
                    <button
                      class="icon-action-btn"
                      (click)="
                        goToCompanyJobApprovalDetailPage(jobApproval.job_id)
                      "
                    >
                      <span class="material-icons eye-icon">visibility</span>
                    </button>

                    <div class="action-buttons-group">
                      <button
                        *ngIf="jobApproval.status === 'pending'"
                        class="approve-btn"
                        (click)="openJobAcceptDialogBox(jobApproval)"
                      >
                        <i class="bi bi-check-lg"></i>
                        Approve
                      </button>

                      <button
                        *ngIf="jobApproval.status === 'pending'"
                        class="reject-btn"
                        (click)="openJobRejectDialogBox(jobApproval)"
                      >
                        <i class="bi bi-x-lg"></i>
                        Reject
                      </button>

                      <span
                        *ngIf="jobApproval.status !== 'pending'"
                        class="processed-text"
                      >
                        Processed
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pagination" *ngIf="jobApprovals.length > 0">
          <span
            >Showing {{ showingFrom }} - {{ showingTo }} of {{ total }}</span
          >
          <div class="page-controls">
            <button [disabled]="page === 1" (click)="prevPage()">
              <i class="bi bi-chevron-left"></i>
            </button>

            <span>Page {{ page }} / {{ totalPages }}</span>

            <button [disabled]="page === totalPages" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template #showMessage>
      <div class="no-data">
        <span class="material-icons">search_off</span>
        <h3>No job requests found</h3>
        <p>No jobs match the current search criteria or filters.</p>
        <button class="reset-filter-btn" (click)="resetFilters()">
          <span class="material-icons">restart_alt</span> Clear Filters
        </button>
      </div>
    </ng-template>
  </ng-template>
</div>
